import featureFlagReducer from "@redux/reducer/featureFlagSlice";
import userReducer from "@redux/reducer/userSlice";
import workflowReducer from "@redux/reducer/workflowSlice";
import { combineReducers } from "@reduxjs/toolkit";

import licenseTenantSlice from "./licenseTenantSlice";
import systemSettingSlice from "./systemSettingSlice";

import { announcementApi } from "@/services/announcement";
import { apiKeyApi } from "@/services/apiKey";
import { jobApi } from "@/services/file";
import { apiIpWhitelist } from "@/services/ipWhitelist";
import { llmSampleApi } from "@/services/llmSample";
import { metadataApi } from "@/services/metadata";
import { pipelineApi } from "@/services/pipeline";
import { retentionPoliciesApi } from "@/services/retentionPolicy";
import { statisticApi } from "@/services/statistic";
import { systemSettingApi } from "@/services/systemSetting";
import { teamApi } from "@/services/team";
import { templateApi } from "@/services/template";
import { tenantConfigApi } from "@/services/tenantConfig";
import { userApi } from "@/services/user";
import { workflowApi } from "@/services/workflow";

export const rootReducer = combineReducers({
  user: userReducer,
  workflow: workflowReducer,
  featureFlag: featureFlagReducer,
  licenseTenant: licenseTenantSlice,
  systemSetting: systemSettingSlice,
  [metadataApi.reducerPath]: metadataApi.reducer,
  [workflowApi.reducerPath]: workflowApi.reducer,
  [teamApi.reducerPath]: teamApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [jobApi.reducerPath]: jobApi.reducer,
  [pipelineApi.reducerPath]: pipelineApi.reducer,
  [templateApi.reducerPath]: templateApi.reducer,
  [llmSampleApi.reducerPath]: llmSampleApi.reducer,
  [statisticApi.reducerPath]: statisticApi.reducer,
  [apiKeyApi.reducerPath]: apiKeyApi.reducer,
  [apiIpWhitelist.reducerPath]: apiIpWhitelist.reducer,
  [systemSettingApi.reducerPath]: systemSettingApi.reducer,
  [retentionPoliciesApi.reducerPath]: retentionPoliciesApi.reducer,
  [tenantConfigApi.reducerPath]: tenantConfigApi.reducer,
  [announcementApi.reducerPath]: announcementApi.reducer,
});
